import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";
import GeneralMode from './GeneralMode';
import StudentMode from './StudentMode';

export default function ({dataMode, setDataMode, dataType, setDataType}) {
    const dispatch = useDispatch();

    if (dataMode === 'student') {
        return (
            <StudentMode
                dataMode={dataMode}
                setDataMode={setDataMode}
                dataType={dataType}
                setDataType={setDataType}
            />
        );
    }

    return (
        <GeneralMode
            dataMode={dataMode}
            setDataMode={setDataMode}
            dataType={dataType}
            setDataType={setDataType}
        />
    );
}
